/* CozyMelt — bundle-picker.js
   Pack + Color pickers → match variant → update variantId + price
   ------------------------------------------------------------- */
(function () {
  'use strict';

  function formatMoneyEUR(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  }

  function init(bundleEl) {
    var json = bundleEl.querySelector('[data-product-json]');
    if (!json) return;

    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      console.warn('[bundle] invalid product JSON', e);
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    var packPos = parseInt(bundleEl.dataset.packPosition, 10) || 1;
    var colorPos = parseInt(bundleEl.dataset.colorPosition, 10) || 2;

    var variantInput = bundleEl.querySelector('[data-variant-id]');
    var atcPrice = bundleEl.querySelector('[data-atc-price]');
    var selectedColorLabel = bundleEl.querySelector('[data-selected-color]');
    var stripNow = bundleEl.querySelector('[data-strip-now]');
    var stripCompare = bundleEl.querySelector('[data-strip-compare]');
    var stripSave = bundleEl.querySelector('[data-strip-save]');

    var PACK_META = {
      '1': { price: '21,99 €', compare: '31,99 €', save: 'Ahorras 10 €' },
      '2': { price: '34,99 €', compare: '63,98 €', save: 'Ahorras 28,99 €' },
      '3': { price: '49,99 €', compare: '95,97 €', save: 'Ahorras 45,98 €' }
    };

    function findVariant() {
      var packInput = bundleEl.querySelector('[data-pack-input]:checked');
      var colorInput = bundleEl.querySelector('[data-color-input]:checked');
      var pack = packInput ? packInput.value : null;
      var color = colorInput ? colorInput.value : null;

      return variants.find(function (v) {
        var okPack = pack ? v['option' + packPos] === pack : true;
        var okColor = color ? v['option' + colorPos] === color : true;
        return okPack && okColor && v.available !== false;
      }) || variants[0];
    }

    function update() {
      var variant = findVariant();
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (atcPrice) atcPrice.textContent = formatMoneyEUR(variant.price);
      if (selectedColorLabel) {
        var colorInput = bundleEl.querySelector('[data-color-input]:checked');
        if (colorInput) selectedColorLabel.textContent = colorInput.value;
      }

      var packInput = bundleEl.querySelector('[data-pack-input]:checked');
      if (packInput && stripNow) {
        var packNum = (packInput.value.match(/\d/) || ['2'])[0];
        var meta = PACK_META[packNum] || PACK_META['2'];
        stripNow.textContent = meta.price;
        if (stripCompare) stripCompare.textContent = meta.compare;
        if (stripSave) stripSave.textContent = meta.save;
      }

      // Update active class en labels
      bundleEl.querySelectorAll('[data-pack-input]').forEach(function (inp) {
        var label = inp.closest('label');
        if (!label) return;
        label.classList.toggle('bundle-option--active', inp.checked);
      });
      bundleEl.querySelectorAll('[data-color-input]').forEach(function (inp) {
        var label = inp.closest('label');
        if (!label) return;
        label.classList.toggle('color-swatch--active', inp.checked);
      });
    }

    bundleEl.addEventListener('change', function (e) {
      if (e.target.matches('[data-pack-input], [data-color-input]')) update();
    });

    // Init
    update();
  }

  document.querySelectorAll('[data-bundle]').forEach(init);
})();
